import {
  TextBlock,
  InputBlock,
  InputUploadBlock,
  ConditionBlock,
  DecisionBlock,
  TeleportBlock,
  // SendyBlock,
  RedirectBlock,
  DocumentBlock,
  DataBlock,
  BookingBlock,
  EmailBlock,
  // ScoroBlock,
  UploadBlock,
  MultipleChoiceBlock,
  // ReviewBlock,
  ShareBlock,
  GTMBlock,
  PaymentBlock,
  CalculationBlock,
  CommentBlock,
  SheetBlock,
  MatchBlock,
  ClassifyBlock,
  MatchV2Block,
  AiBlock,
  RouterBlock,
  LoginBlock,
  // CalendarBlock,
  ProjectBlock,
  SubscriptionBlock,
  SubscriptionCheckBlock,
  InvoiceBlock,
} from './';

export const nodeTypes = {
  textBlock: TextBlock,
  inputBlock: InputBlock,
  inputuploadBlock: InputUploadBlock,
  conditionBlock: ConditionBlock,
  decisionBlock: DecisionBlock,
  teleportBlock: TeleportBlock,
  // sendyBlock: SendyBlock,
  redirectBlock: RedirectBlock,
  documentBlock: DocumentBlock,
  dataBlock: DataBlock,
  bookingBlock: BookingBlock,
  emailBlock: EmailBlock,
  // scoroBlock: ScoroBlock,
  uploadBlock: UploadBlock,
  multipleChoiceBlock: MultipleChoiceBlock,
  // reviewBlock: ReviewBlock,
  shareBlock: ShareBlock,
  gtmBlock: GTMBlock,
  paymentBlock: PaymentBlock,
  calculationBlock: CalculationBlock,
  commentBlock: CommentBlock,
  sheetBlock: SheetBlock,
  matchBlock: MatchBlock,
  classifyBlock: ClassifyBlock,
  matchV2Block: MatchV2Block,
  aiBlock: AiBlock,
  routerBlock: RouterBlock,
  loginBlock: LoginBlock,
  // calendarBlock: CalendarBlock,
  projectBlock: ProjectBlock,
  subscriptionBlock: SubscriptionBlock,
  subscriptioncheckBlock: SubscriptionCheckBlock,
  invoiceBlock: InvoiceBlock,
};
